import { render, staticRenderFns } from "./lift-groups.vue?vue&type=template&id=24dfca9e&scoped=true&"
import script from "./lift-groups.vue?vue&type=script&lang=js&"
export * from "./lift-groups.vue?vue&type=script&lang=js&"
import style0 from "./lift-groups.vue?vue&type=style&index=0&id=24dfca9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfca9e",
  null
  
)

export default component.exports